// TODO: remove cast once types are regenerated post-deploy
// supabase.from('bags') uses `as any` because the bags table is not yet in auto-generated types.ts
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useTenant } from '@/hooks/useTenant';

export const useBag = (bagId: string | null) => {
  const { tenant } = useTenant();
  return useQuery({
    queryKey: ['bag', tenant?.id, bagId],
    enabled: !!tenant?.id && !!bagId,
    queryFn: async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const { data, error } = await (supabase as any)
        .from('bags')
        .select(`
          *,
          customer:customers(*),
          sales(*, sale_items(*, products(name)), payment_status),
          shipments(*)
        `)
        .eq('id', bagId!)
        .eq('tenant_id', tenant!.id)
        .single();
      if (error) throw error;
      return data;
    },
  });
};
